const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPopupInstallations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1.534056, 0, 0, 1.540835, 79.228165, -286.397583)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(0.414469, 0, 0, 0.3818, -48.514217, 104.952553)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path260"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g23",
    transform: "matrix(1.96377, 0, 0, 2.323853, -157.366409, -70.513489)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "white",
      fillOpacity: 1,
      strokeWidth: 0.371069
    },
    id: "rect1",
    width: 24.12,
    height: 5.144,
    x: 84.314,
    y: 121.617
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "white",
      fillOpacity: 1,
      strokeWidth: 0.371069
    },
    id: "rect1-6",
    width: 24.12,
    height: 5.144,
    x: 84.365,
    y: 152.884
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "white",
      fillOpacity: 1,
      strokeWidth: 0.443009
    },
    id: "rect1-0-1-0",
    width: 29.862,
    height: 5.922,
    x: 177.881,
    y: -142.705,
    transform: "matrix(0, 1, -1, 0, -43.346184, -52.349792)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPopupInstallations);
export default __webpack_public_path__ + "static/media/map_popup_installations.9e20991eec3d2ed059185190175a7e98.svg";
export { ForwardRef as ReactComponent };